var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSkipBack48Line = function SvgIconSkipBack48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.55 37.2 10.4 26.05a2.903 2.903 0 0 1 0-4.1L21.55 10.8l2.4 2.4L13.15 24l10.8 10.8-2.4 2.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.55 37.2 24.4 26.05a2.903 2.903 0 0 1 0-4.1L35.55 10.8l2.4 2.4L27.15 24l10.8 10.8-2.4 2.4Z",
    fill: "current"
  })));
};
export default SvgIconSkipBack48Line;